<app-navbar-style-three></app-navbar-style-three>
<section class="bg-image">
    <div class="container">
        <div class="pt-3 pb-3" *ngIf="!fetchinData">
            <div class="row">
                <div class="col-md-3">
                    <div align="left" style="padding-left: 20px">
                        <p style="font-size: 26px">Clubs</p>
                    </div>
                    <div class="list-group list-group-flush">
                        <ng-container *ngFor="let item of items">
                            <button
                                [class.active]="selectedItem === item.Url"
                                (click)="selectItem(item.Url)"
                                class="newA linkStyle list-group-item list-group-item-action"
                            >
                                {{ item.Name }}
                            </button>
                        </ng-container>
                    </div>
                </div>
                <div class="col-md-9">
                    <div style="min-height: 800px">
                        <div>
                            <h3>{{ selectedItemName }}</h3>
                            <hr />
                            
                            <!-- English Club -->
                            <div class="container" *ngIf="selectedItem && selectedItem == 'english-club'">
                                <div class="card" style="padding: 20px">
                                    <ng-container *ngIf="english_club_data == null" class="spinner-overlay">
                                        <span class="fetching-data-text">No Data Found</span>
                                    </ng-container>
                                    <ng-container *ngIf="english_club_data != null">
                                        <div class="row justify-content-center">
                                            <article class="col-md-12 text-justify p-4">
                                                <div *ngIf="english_club_data?.ShowAttachments?.length > 0">
                                                    <div id="englishClubCarousel" class="carousel slide" data-bs-ride="carousel">
                                                        
                                                        <!-- Indicators / Dots -->
                                                        <div class="carousel-indicators">
                                                            <button 
                                                                *ngFor="let img of english_club_data.ShowAttachments; let i = index"
                                                                type="button" 
                                                                data-bs-target="#englishClubCarousel"
                                                                [attr.data-bs-slide-to]="i"
                                                                [class.active]="i === 0"
                                                                aria-current="true"
                                                                [attr.aria-label]="'Slide ' + (i + 1)">
                                                            </button>
                                                        </div>

                                                        <!-- Slides -->
                                                        <div class="carousel-inner">
                                                            <div 
                                                                *ngFor="let img of english_club_data.ShowAttachments; let i = index" 
                                                                class="carousel-item" 
                                                                [class.active]="i === 0">

                                                                <img 
                                                                    [src]="img.FilePath" 
                                                                    class="d-block w-100 club-image" 
                                                                    style="height: 300px; object-fit: cover; border-radius: 10px;"
                                                                    alt="Club Image" />
                                                            </div>
                                                        </div>

                                                        <!-- Controls -->
                                                        <button class="carousel-control-prev" type="button" data-bs-target="#englishClubCarousel" data-bs-slide="prev">
                                                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                            <span class="visually-hidden">Previous</span>
                                                        </button>
                                                        <button class="carousel-control-next" type="button" data-bs-target="#englishClubCarousel" data-bs-slide="next">
                                                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                            <span class="visually-hidden">Next</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <p style="text-align: justify" 
                                                    [innerHTML]="english_club_data.DetailsEn"></p>
                                            </article>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>

                            <!-- YCS Club -->
                            <div class="container" *ngIf="selectedItem && selectedItem == 'ycs-club'">
                                <div class="card" style="padding: 20px">
                                    <ng-container *ngIf="ycs_club_data == null" class="spinner-overlay">
                                        <span class="fetching-data-text">No Data Found</span>
                                    </ng-container>
                                    <ng-container *ngIf="ycs_club_data != null">
                                        <div class="row justify-content-center">
                                            <article class="col-md-12 text-justify p-4">
                                                <div *ngIf="ycs_club_data?.ShowAttachments?.length > 0">
                                                    <div id="ycsClubCarousel" class="carousel slide" data-bs-ride="carousel">
                                                        
                                                        <!-- Indicators / Dots -->
                                                        <div class="carousel-indicators">
                                                            <button 
                                                                *ngFor="let img of ycs_club_data.ShowAttachments; let i = index"
                                                                type="button" 
                                                                data-bs-target="#ycsClubCarousel"
                                                                [attr.data-bs-slide-to]="i"
                                                                [class.active]="i === 0"
                                                                aria-current="true"
                                                                [attr.aria-label]="'Slide ' + (i + 1)">
                                                            </button>
                                                        </div>

                                                        <!-- Slides -->
                                                        <div class="carousel-inner">
                                                            <div 
                                                                *ngFor="let img of ycs_club_data.ShowAttachments; let i = index" 
                                                                class="carousel-item" 
                                                                [class.active]="i === 0">

                                                                <img 
                                                                    [src]="img.FilePath" 
                                                                    class="d-block w-100 club-image" 
                                                                    style="height: 300px; object-fit: cover; border-radius: 10px;"
                                                                    alt="Club Image" />
                                                            </div>
                                                        </div>

                                                        <!-- Controls -->
                                                        <button class="carousel-control-prev" type="button" data-bs-target="#ycsClubCarousel" data-bs-slide="prev">
                                                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                            <span class="visually-hidden">Previous</span>
                                                        </button>
                                                        <button class="carousel-control-next" type="button" data-bs-target="#ycsClubCarousel" data-bs-slide="next">
                                                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                            <span class="visually-hidden">Next</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <p style="text-align: justify" 
                                                    [innerHTML]="ycs_club_data.DetailsEn"></p>
                                            </article>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>

                            <!-- Cultural Club -->
                            <div class="container" *ngIf="selectedItem && selectedItem == 'cultural-club'">
                                <div class="card" style="padding: 20px">
                                    <ng-container *ngIf="culture_club_data == null" class="spinner-overlay">
                                        <span class="fetching-data-text">No Data Found</span>
                                    </ng-container>
                                    <ng-container *ngIf="culture_club_data != null">
                                        <div class="row justify-content-center">
                                            <article class="col-md-12 text-justify p-4">
                                                <div *ngIf="culture_club_data?.ShowAttachments?.length > 0">
                                                    <div id="culturalClubCarousel" class="carousel slide" data-bs-ride="carousel">
                                                        
                                                        <!-- Indicators / Dots -->
                                                        <div class="carousel-indicators">
                                                            <button 
                                                                *ngFor="let img of culture_club_data.ShowAttachments; let i = index"
                                                                type="button" 
                                                                data-bs-target="#culturalClubCarousel"
                                                                [attr.data-bs-slide-to]="i"
                                                                [class.active]="i === 0"
                                                                aria-current="true"
                                                                [attr.aria-label]="'Slide ' + (i + 1)">
                                                            </button>
                                                        </div>

                                                        <!-- Slides -->
                                                        <div class="carousel-inner">
                                                            <div 
                                                                *ngFor="let img of culture_club_data.ShowAttachments; let i = index" 
                                                                class="carousel-item" 
                                                                [class.active]="i === 0">

                                                                <img 
                                                                    [src]="img.FilePath" 
                                                                    class="d-block w-100 club-image" 
                                                                    style="height: 300px; object-fit: cover; border-radius: 10px;"
                                                                    alt="Club Image" />
                                                            </div>
                                                        </div>

                                                        <!-- Controls -->
                                                        <button class="carousel-control-prev" type="button" data-bs-target="#culturalClubCarousel" data-bs-slide="prev">
                                                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                            <span class="visually-hidden">Previous</span>
                                                        </button>
                                                        <button class="carousel-control-next" type="button" data-bs-target="#culturalClubCarousel" data-bs-slide="next">
                                                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                            <span class="visually-hidden">Next</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <p style="text-align: justify" 
                                                    [innerHTML]="culture_club_data.DetailsEn"></p>
                                            </article>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>

                            <!-- Knowledge Club -->
                            <div class="container" *ngIf="selectedItem && selectedItem == 'knowledge-fiesta-club'">
                                <div class="card" style="padding: 20px">
                                    <ng-container *ngIf="knowledge_club_data == null" class="spinner-overlay">
                                        <span class="fetching-data-text">No Data Found</span>
                                    </ng-container>
                                    <ng-container *ngIf="knowledge_club_data != null">
                                        <div class="row justify-content-center">
                                            <article class="col-md-12 text-justify p-4">
                                                <div *ngIf="knowledge_club_data?.ShowAttachments?.length > 0">
                                                    <div id="knowledgeClubCarousel" class="carousel slide" data-bs-ride="carousel">
                                                        
                                                        <!-- Indicators / Dots -->
                                                        <div class="carousel-indicators">
                                                            <button 
                                                                *ngFor="let img of knowledge_club_data.ShowAttachments; let i = index"
                                                                type="button" 
                                                                data-bs-target="#knowledgeClubCarousel"
                                                                [attr.data-bs-slide-to]="i"
                                                                [class.active]="i === 0"
                                                                aria-current="true"
                                                                [attr.aria-label]="'Slide ' + (i + 1)">
                                                            </button>
                                                        </div>

                                                        <!-- Slides -->
                                                        <div class="carousel-inner">
                                                            <div 
                                                                *ngFor="let img of knowledge_club_data.ShowAttachments; let i = index" 
                                                                class="carousel-item" 
                                                                [class.active]="i === 0">

                                                                <img 
                                                                    [src]="img.FilePath" 
                                                                    class="d-block w-100 club-image" 
                                                                    style="height: 300px; object-fit: cover; border-radius: 10px;"
                                                                    alt="Club Image" />
                                                            </div>
                                                        </div>

                                                        <!-- Controls -->
                                                        <button class="carousel-control-prev" type="button" data-bs-target="#knowledgeClubCarousel" data-bs-slide="prev">
                                                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                            <span class="visually-hidden">Previous</span>
                                                        </button>
                                                        <button class="carousel-control-next" type="button" data-bs-target="#knowledgeClubCarousel" data-bs-slide="next">
                                                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                            <span class="visually-hidden">Next</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <p style="text-align: justify" 
                                                    [innerHTML]="knowledge_club_data.DetailsEn"></p>
                                            </article>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>

                            <!-- Debate Club -->
                            <div class="container" *ngIf="selectedItem && selectedItem == 'debate-club'">
                                <div class="card" style="padding: 20px">
                                    <ng-container *ngIf="debate_club_data == null" class="spinner-overlay">
                                        <span class="fetching-data-text">No Data Found</span>
                                    </ng-container>
                                    <ng-container *ngIf="debate_club_data != null">
                                        <div class="row justify-content-center">
                                            <article class="col-md-12 text-justify p-4">
                                                <div *ngIf="debate_club_data?.ShowAttachments?.length > 0">
                                                    <div id="debateClubCarousel" class="carousel slide" data-bs-ride="carousel">
                                                        
                                                        <!-- Indicators / Dots -->
                                                        <div class="carousel-indicators">
                                                            <button 
                                                                *ngFor="let img of debate_club_data.ShowAttachments; let i = index"
                                                                type="button" 
                                                                data-bs-target="#debateClubCarousel"
                                                                [attr.data-bs-slide-to]="i"
                                                                [class.active]="i === 0"
                                                                aria-current="true"
                                                                [attr.aria-label]="'Slide ' + (i + 1)">
                                                            </button>
                                                        </div>

                                                        <!-- Slides -->
                                                        <div class="carousel-inner">
                                                            <div 
                                                                *ngFor="let img of debate_club_data.ShowAttachments; let i = index" 
                                                                class="carousel-item" 
                                                                [class.active]="i === 0">

                                                                <img 
                                                                    [src]="img.FilePath" 
                                                                    class="d-block w-100 club-image" 
                                                                    style="height: 300px; object-fit: cover; border-radius: 10px;"
                                                                    alt="Club Image" />
                                                            </div>
                                                        </div>

                                                        <!-- Controls -->
                                                        <button class="carousel-control-prev" type="button" data-bs-target="#debateClubCarousel" data-bs-slide="prev">
                                                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                            <span class="visually-hidden">Previous</span>
                                                        </button>
                                                        <button class="carousel-control-next" type="button" data-bs-target="#debateClubCarousel" data-bs-slide="next">
                                                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                            <span class="visually-hidden">Next</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <p style="text-align: justify" 
                                                    [innerHTML]="debate_club_data.DetailsEn"></p>
                                            </article>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>

                            <!-- Chess Club -->
                            <div class="container" *ngIf="selectedItem && selectedItem == 'chess-club'">
                                <div class="card" style="padding: 20px">
                                    <ng-container *ngIf="chess_club_data == null" class="spinner-overlay">
                                        <span class="fetching-data-text">No Data Found</span>
                                    </ng-container>
                                    <ng-container *ngIf="chess_club_data != null">
                                        <div class="row justify-content-center">
                                            <article class="col-md-12 text-justify p-4">
                                                <div *ngIf="chess_club_data?.ShowAttachments?.length > 0">
                                                    <div id="chessClubCarousel" class="carousel slide" data-bs-ride="carousel">
                                                        
                                                        <!-- Indicators / Dots -->
                                                        <div class="carousel-indicators">
                                                            <button 
                                                                *ngFor="let img of chess_club_data.ShowAttachments; let i = index"
                                                                type="button" 
                                                                data-bs-target="#chessClubCarousel"
                                                                [attr.data-bs-slide-to]="i"
                                                                [class.active]="i === 0"
                                                                aria-current="true"
                                                                [attr.aria-label]="'Slide ' + (i + 1)">
                                                            </button>
                                                        </div>

                                                        <!-- Slides -->
                                                        <div class="carousel-inner">
                                                            <div 
                                                                *ngFor="let img of chess_club_data.ShowAttachments; let i = index" 
                                                                class="carousel-item" 
                                                                [class.active]="i === 0">

                                                                <img 
                                                                    [src]="img.FilePath" 
                                                                    class="d-block w-100 club-image" 
                                                                    style="height: 300px; object-fit: cover; border-radius: 10px;"
                                                                    alt="Club Image" />
                                                            </div>
                                                        </div>

                                                        <!-- Controls -->
                                                        <button class="carousel-control-prev" type="button" data-bs-target="#chessClubCarousel" data-bs-slide="prev">
                                                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                            <span class="visually-hidden">Previous</span>
                                                        </button>
                                                        <button class="carousel-control-next" type="button" data-bs-target="#chessClubCarousel" data-bs-slide="next">
                                                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                            <span class="visually-hidden">Next</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <p style="text-align: justify" 
                                                    [innerHTML]="chess_club_data.DetailsEn"></p>
                                            </article>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>

                            <!-- Art Club -->
                            <div class="container" *ngIf="selectedItem && selectedItem == 'art-club'">
                                <div class="card" style="padding: 20px">
                                    <ng-container *ngIf="art_club_data == null" class="spinner-overlay">
                                        <span class="fetching-data-text">No Data Found</span>
                                    </ng-container>
                                    <ng-container *ngIf="art_club_data != null">
                                        <div class="row justify-content-center">
                                            <article class="col-md-12 text-justify p-4">
                                                <div *ngIf="art_club_data?.ShowAttachments?.length > 0">
                                                    <div id="artClubCarousel" class="carousel slide" data-bs-ride="carousel">
                                                        
                                                        <!-- Indicators / Dots -->
                                                        <div class="carousel-indicators">
                                                            <button 
                                                                *ngFor="let img of art_club_data.ShowAttachments; let i = index"
                                                                type="button" 
                                                                data-bs-target="#artClubCarousel"
                                                                [attr.data-bs-slide-to]="i"
                                                                [class.active]="i === 0"
                                                                aria-current="true"
                                                                [attr.aria-label]="'Slide ' + (i + 1)">
                                                            </button>
                                                        </div>

                                                        <!-- Slides -->
                                                        <div class="carousel-inner">
                                                            <div 
                                                                *ngFor="let img of art_club_data.ShowAttachments; let i = index" 
                                                                class="carousel-item" 
                                                                [class.active]="i === 0">

                                                                <img 
                                                                    [src]="img.FilePath" 
                                                                    class="d-block w-100 club-image" 
                                                                    style="height: 300px; object-fit: cover; border-radius: 10px;"
                                                                    alt="Club Image" />
                                                            </div>
                                                        </div>

                                                        <!-- Controls -->
                                                        <button class="carousel-control-prev" type="button" data-bs-target="#artClubCarousel" data-bs-slide="prev">
                                                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                            <span class="visually-hidden">Previous</span>
                                                        </button>
                                                        <button class="carousel-control-next" type="button" data-bs-target="#artClubCarousel" data-bs-slide="next">
                                                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                            <span class="visually-hidden">Next</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <p style="text-align: justify" 
                                                    [innerHTML]="art_club_data.DetailsEn"></p>
                                            </article>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>

                            <!-- Ecology Club -->
                            <div class="container" *ngIf="selectedItem && selectedItem == 'ecology-club'">
                                <div class="card" style="padding: 20px">
                                    <ng-container *ngIf="ecology_club_data == null" class="spinner-overlay">
                                        <span class="fetching-data-text">No Data Found</span>
                                    </ng-container>
                                    <ng-container *ngIf="ecology_club_data != null">
                                        <div class="row justify-content-center">
                                            <article class="col-md-12 text-justify p-4">
                                                <div *ngIf="ecology_club_data?.ShowAttachments?.length > 0">
                                                    <div id="ecologyClubCarousel" class="carousel slide" data-bs-ride="carousel">
                                                        
                                                        <!-- Indicators / Dots -->
                                                        <div class="carousel-indicators">
                                                            <button 
                                                                *ngFor="let img of ecology_club_data.ShowAttachments; let i = index"
                                                                type="button" 
                                                                data-bs-target="#ecologyClubCarousel"
                                                                [attr.data-bs-slide-to]="i"
                                                                [class.active]="i === 0"
                                                                aria-current="true"
                                                                [attr.aria-label]="'Slide ' + (i + 1)">
                                                            </button>
                                                        </div>

                                                        <!-- Slides -->
                                                        <div class="carousel-inner">
                                                            <div 
                                                                *ngFor="let img of ecology_club_data.ShowAttachments; let i = index" 
                                                                class="carousel-item" 
                                                                [class.active]="i === 0">

                                                                <img 
                                                                    [src]="img.FilePath" 
                                                                    class="d-block w-100 club-image" 
                                                                    style="height: 300px; object-fit: cover; border-radius: 10px;"
                                                                    alt="Club Image" />
                                                            </div>
                                                        </div>

                                                        <!-- Controls -->
                                                        <button class="carousel-control-prev" type="button" data-bs-target="#ecologyClubCarousel" data-bs-slide="prev">
                                                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                            <span class="visually-hidden">Previous</span>
                                                        </button>
                                                        <button class="carousel-control-next" type="button" data-bs-target="#ecologyClubCarousel" data-bs-slide="next">
                                                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                            <span class="visually-hidden">Next</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <p style="text-align: justify" 
                                                    [innerHTML]="ecology_club_data.DetailsEn"></p>
                                            </article>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>

                            <!-- Art and Handwriting Club -->
                            <div class="container" *ngIf="selectedItem && selectedItem == 'art-handwriting-club'">
                                <div class="card" style="padding: 20px">
                                    <ng-container *ngIf="art_handwriting_club_data == null" class="spinner-overlay">
                                        <span class="fetching-data-text">No Data Found</span>
                                    </ng-container>
                                    <ng-container *ngIf="art_handwriting_club_data != null">
                                        <div class="row justify-content-center">
                                            <article class="col-md-12 text-justify p-4">
                                                <div *ngIf="art_handwriting_club_data?.ShowAttachments?.length > 0">
                                                    <div id="artHandwritingClubCarousel" class="carousel slide" data-bs-ride="carousel">
                                                        
                                                        <!-- Indicators / Dots -->
                                                        <div class="carousel-indicators">
                                                            <button 
                                                                *ngFor="let img of art_handwriting_club_data.ShowAttachments; let i = index"
                                                                type="button" 
                                                                data-bs-target="#artHandwritingClubCarousel"
                                                                [attr.data-bs-slide-to]="i"
                                                                [class.active]="i === 0"
                                                                aria-current="true"
                                                                [attr.aria-label]="'Slide ' + (i + 1)">
                                                            </button>
                                                        </div>

                                                        <!-- Slides -->
                                                        <div class="carousel-inner">
                                                            <div 
                                                                *ngFor="let img of art_handwriting_club_data.ShowAttachments; let i = index" 
                                                                class="carousel-item" 
                                                                [class.active]="i === 0">

                                                                <img 
                                                                    [src]="img.FilePath" 
                                                                    class="d-block w-100 club-image" 
                                                                    style="height: 300px; object-fit: cover; border-radius: 10px;"
                                                                    alt="Club Image" />
                                                            </div>
                                                        </div>

                                                        <!-- Controls -->
                                                        <button class="carousel-control-prev" type="button" data-bs-target="#artHandwritingClubCarousel" data-bs-slide="prev">
                                                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                            <span class="visually-hidden">Previous</span>
                                                        </button>
                                                        <button class="carousel-control-next" type="button" data-bs-target="#artHandwritingClubCarousel" data-bs-slide="next">
                                                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                            <span class="visually-hidden">Next</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <p style="text-align: justify" 
                                                    [innerHTML]="art_handwriting_club_data.DetailsEn"></p>
                                            </article>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>

                            <!-- Science Club -->
                            <div class="container" *ngIf="selectedItem && selectedItem == 'science-club'">
                                <div class="card" style="padding: 20px">
                                    <ng-container *ngIf="science_club_data == null" class="spinner-overlay">
                                        <span class="fetching-data-text">No Data Found</span>
                                    </ng-container>
                                    <ng-container *ngIf="science_club_data != null">
                                        <div class="row justify-content-center">
                                            <article class="col-md-12 text-justify p-4">
                                                <div *ngIf="science_club_data?.ShowAttachments?.length > 0">
                                                    <div id="scienceClubCarousel" class="carousel slide" data-bs-ride="carousel">
                                                        
                                                        <!-- Indicators / Dots -->
                                                        <div class="carousel-indicators">
                                                            <button 
                                                                *ngFor="let img of science_club_data.ShowAttachments; let i = index"
                                                                type="button" 
                                                                data-bs-target="#scienceClubCarousel"
                                                                [attr.data-bs-slide-to]="i"
                                                                [class.active]="i === 0"
                                                                aria-current="true"
                                                                [attr.aria-label]="'Slide ' + (i + 1)">
                                                            </button>
                                                        </div>

                                                        <!-- Slides -->
                                                        <div class="carousel-inner">
                                                            <div 
                                                                *ngFor="let img of science_club_data.ShowAttachments; let i = index" 
                                                                class="carousel-item" 
                                                                [class.active]="i === 0">

                                                                <img 
                                                                    [src]="img.FilePath" 
                                                                    class="d-block w-100 club-image" 
                                                                    style="height: 300px; object-fit: cover; border-radius: 10px;"
                                                                    alt="Club Image" />
                                                            </div>
                                                        </div>

                                                        <!-- Controls -->
                                                        <button class="carousel-control-prev" type="button" data-bs-target="#scienceClubCarousel" data-bs-slide="prev">
                                                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                            <span class="visually-hidden">Previous</span>
                                                        </button>
                                                        <button class="carousel-control-next" type="button" data-bs-target="#scienceClubCarousel" data-bs-slide="next">
                                                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                            <span class="visually-hidden">Next</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <p style="text-align: justify" 
                                                    [innerHTML]="science_club_data.DetailsEn"></p>
                                            </article>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>

                            <!-- Sports Club -->
                            <div class="container" *ngIf="selectedItem && selectedItem == 'sports-club'">
                                <div class="card" style="padding: 20px">
                                    <ng-container *ngIf="sports_club_data == null" class="spinner-overlay">
                                        <span class="fetching-data-text">No Data Found</span>
                                    </ng-container>
                                    <ng-container *ngIf="sports_club_data != null">
                                        <div class="row justify-content-center">
                                            <article class="col-md-12 text-justify p-4">
                                                <div *ngIf="sports_club_data?.ShowAttachments?.length > 0">
                                                    <div id="sportsClubCarousel" class="carousel slide" data-bs-ride="carousel">
                                                        
                                                        <!-- Indicators / Dots -->
                                                        <div class="carousel-indicators">
                                                            <button 
                                                                *ngFor="let img of sports_club_data.ShowAttachments; let i = index"
                                                                type="button" 
                                                                data-bs-target="#sportsClubCarousel"
                                                                [attr.data-bs-slide-to]="i"
                                                                [class.active]="i === 0"
                                                                aria-current="true"
                                                                [attr.aria-label]="'Slide ' + (i + 1)">
                                                            </button>
                                                        </div>

                                                        <!-- Slides -->
                                                        <div class="carousel-inner">
                                                            <div 
                                                                *ngFor="let img of sports_club_data.ShowAttachments; let i = index" 
                                                                class="carousel-item" 
                                                                [class.active]="i === 0">

                                                                <img 
                                                                    [src]="img.FilePath" 
                                                                    class="d-block w-100 club-image" 
                                                                    style="height: 300px; object-fit: cover; border-radius: 10px;"
                                                                    alt="Club Image" />
                                                            </div>
                                                        </div>

                                                        <!-- Controls -->
                                                        <button class="carousel-control-prev" type="button" data-bs-target="#sportsClubCarousel" data-bs-slide="prev">
                                                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                            <span class="visually-hidden">Previous</span>
                                                        </button>
                                                        <button class="carousel-control-next" type="button" data-bs-target="#sportsClubCarousel" data-bs-slide="next">
                                                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                            <span class="visually-hidden">Next</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <p style="text-align: justify" 
                                                    [innerHTML]="sports_club_data.DetailsEn"></p>
                                            </article>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>

                            <!-- Math Club -->
                            <div class="container" *ngIf="selectedItem && selectedItem == 'math-club'">
                                <div class="card" style="padding: 20px">
                                    <ng-container *ngIf="math_club_data == null" class="spinner-overlay">
                                        <span class="fetching-data-text">No Data Found</span>
                                    </ng-container>
                                    <ng-container *ngIf="math_club_data != null">
                                        <div class="row justify-content-center">
                                            <article class="col-md-12 text-justify p-4">
                                                <div *ngIf="math_club_data?.ShowAttachments?.length > 0">
                                                    <div id="mathClubCarousel" class="carousel slide" data-bs-ride="carousel">
                                                        
                                                        <!-- Indicators / Dots -->
                                                        <div class="carousel-indicators">
                                                            <button 
                                                                *ngFor="let img of math_club_data.ShowAttachments; let i = index"
                                                                type="button" 
                                                                data-bs-target="#mathClubCarousel"
                                                                [attr.data-bs-slide-to]="i"
                                                                [class.active]="i === 0"
                                                                aria-current="true"
                                                                [attr.aria-label]="'Slide ' + (i + 1)">
                                                            </button>
                                                        </div>

                                                        <!-- Slides -->
                                                        <div class="carousel-inner">
                                                            <div 
                                                                *ngFor="let img of math_club_data.ShowAttachments; let i = index" 
                                                                class="carousel-item" 
                                                                [class.active]="i === 0">

                                                                <img 
                                                                    [src]="img.FilePath" 
                                                                    class="d-block w-100 club-image" 
                                                                    style="height: 300px; object-fit: cover; border-radius: 10px;"
                                                                    alt="Club Image" />
                                                            </div>
                                                        </div>

                                                        <!-- Controls -->
                                                        <button class="carousel-control-prev" type="button" data-bs-target="#mathClubCarousel" data-bs-slide="prev">
                                                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                            <span class="visually-hidden">Previous</span>
                                                        </button>
                                                        <button class="carousel-control-next" type="button" data-bs-target="#mathClubCarousel" data-bs-slide="next">
                                                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                            <span class="visually-hidden">Next</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <p style="text-align: justify" 
                                                    [innerHTML]="math_club_data.DetailsEn"></p>
                                            </article>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <br />
        </div>
        <div aria-hidden="true" *ngIf="fetchinData" class="col-lg-12 col-md-12">
            <h5 class="placeholder-glow">
                <span class="placeholder col-12" style="height: 200px"></span>
            </h5>
        </div>
    </div>
</section>